import { IS_DEV } from "@/utils/env";

/** Log an error with context. Dev: full details. Prod: error type only. */
export const logError = (context, error, metadata = {}) => {
  if (IS_DEV) {
    console.error(`[${context}]`, error, metadata);
  } else {
    const errorType = error instanceof Error ? error.name : "Error";
    console.error(`[${context}] ${errorType}`);
  }
};

/** Log info. Dev-only. */
export const logInfo = (context, message, metadata = {}) => {
  if (IS_DEV) console.info(`[${context}]`, message, metadata);
};

/** Log warning. Dev: full details. Prod: context + message only. */
export const logWarn = (context, message, metadata = {}) => {
  if (IS_DEV) {
    console.warn(`[${context}]`, message, metadata);
  } else {
    console.warn(`[${context}] ${message}`);
  }
};

/** Log debug. Dev-only. */
export const logDebug = (context, message, metadata = {}) => {
  if (IS_DEV) console.log(`[${context}]`, message, metadata);
};

export default { logError, logInfo, logWarn, logDebug };
